<template>
  <div style="margin-top: 60px">
    <div style="text-align: center; font-weight: bold; font-size: 36px; margin-bottom: 30px"> 登录</div>
    <el-row type="flex" justify="center" align="middle">
      <el-form ref="dataForm" :rules="rules" :model="dataForm" label-width="80px" style="width: 40%">
        <el-form-item label="用户ID" prop="userId">
          <el-input v-model="dataForm.userId" clearable/>
        </el-form-item>
        <el-form-item label="用户姓名" prop="userName">
          <el-input v-model="dataForm.userName" clearable/>
        </el-form-item>
        <el-form-item label="所在部门" prop="departmentName">
          <el-input v-model="dataForm.departmentName" clearable/>
        </el-form-item>
        <el-form-item label="强制登录" prop="forceLogin" align="start">
          <el-switch v-model="dataForm.forceLogin"> </el-switch>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="dataFormSubmit()"> 登录</el-button>
        </el-form-item>
      </el-form>
    </el-row>
  </div>
</template>

<script>
import {init} from "../js/rtcEngine.min.js";
import {jyxRtcConstants, eventNameConstants} from "../util/Constants.js";
import {showErrorMessage} from "../util/index.js";

export default {
    data() {
        return {
            pageName: "login",
            rtcEngine: null,
            appId: "001", // 流媒体demo测试环境appId
            appToken: "00100",
            // appId: "videocalltest210", // 云柜席测试环境appId
            // appToken: "videocalltest210",
            // appId: "videocallprod210", // 云柜席生产环境appId
            // appToken: "videocallprod210",
            dataForm: {
                userId: "",
                userName: "",
                departmentName: "",
                forceLogin: false
            },
            rules: {
                userId: [
                    {required: true, message: "用户ID不能为空", trigger: "blur"}
                ],
                userName: [
                    {required: true, message: "用户姓名不能为空", trigger: "blur"}
                ],
                departmentName: [
                    {required: true, message: "用户部门不能为空", trigger: "blur"}
                ]
            }
        };
    },
    watch: {},
    created() {
        console.log(this.pageName + " created");
        sessionStorage.setItem(jyxRtcConstants.JYX_RTC_BEFORE_PAGE_NAME, this.pageName);
    },
    mounted() {
        console.log(this.pageName + " mounted");
        sessionStorage.removeItem(jyxRtcConstants.JYX_RTC_LOGIN_OPTIONS);
        sessionStorage.removeItem(jyxRtcConstants.JYX_RTC_ROOM_ID);
        this.dataForm.userId = this.$route.query.userId || "user1";
        this.dataForm.userName = this.$route.query.userName || this.$route.query.userId || "user1";
        this.dataForm.departmentName = this.$route.query.departmentName || "技术部";
        this.init();
        this.subscribeEventHandle();
    },
    methods: {
        init() {
            console.log("init");
            // todo
            // this.rtcEngine = init({serverUrl: "ws://192.168.16.103:8880"});
            // this.rtcEngine = init({serverUrl: "ws://127.0.0.1:8880"});
            // this.rtcEngine = init({serverUrl: "wss://192.168.16.128:8002"});
            // this.rtcEngine = init({serverUrl: "ws://192.168.12.128:8005"});
            // 生产环境信令服务地址
            this.rtcEngine = init({serverUrl: "wss://media.fjjieyu.com:8002"});
            // 测试环境信令服务地址
            // this.rtcEngine = init({serverUrl: "wss://192.168.10.66:8002", selfieSegmentationHost: "https://media.fjjieyu.com:8002"});
            // this.rtcEngine = init({serverUrl: "wss://192.168.16.113:8002"});
            // 打包在第三方环境时启用，在执行脚本中替换RTC_ENGINE_SERVER_URL
            // this.rtcEngine = init({serverUrl: "wss://RTC_ENGINE_SERVER_URL"});
            // this.rtcEngine = init({serverUrl: "wss://10.36.2.61:2080"});
            // this.rtcEngine = init({serverUrl: "ws://192.168.10.66:8000", selfieSegmentationHost: "https://media.fjjieyu.com:8002"});
            console.log("browserInfo", this.rtcEngine.browserInfo);
        },
        dataFormSubmit() {
            this.$refs.dataForm
                .validate((valid) => {
                    if (!valid) {
                        return;
                    }
                    this.login();
                });
        },
        login() {
            let options = {
                appId: this.appId,
                appToken: this.appToken,
                userId: this.dataForm.userId,
                userExtInfo: JSON.stringify(this.dataForm),
                forceLogin: this.dataForm.forceLogin
            };
            console.log("login ", options);
            this.rtcEngine.login(options)
                .then(() => {
                    console.log("login success");
                    sessionStorage.setItem(jyxRtcConstants.JYX_RTC_LOGIN_OPTIONS, JSON.stringify(options));
                    this.$router.push({path: "/message-chat"});
                })
                .catch((error) => {
                    console.log("login error", error);
                    showErrorMessage("登录失败", error);
                });
        },
        onDisconnectHandle(result) {
            console.log("订阅通知事件", eventNameConstants.ON_DISCONNECT, result);
            showErrorMessage("连接异常，请检查你的网络后联系管理员");
        },
        unSubscribeEventHandle() {
        //  取消订阅
            for (let key in eventNameConstants) {
                this.rtcEngine.unSubscribeEvent(eventNameConstants[key]);
            }
        },
        subscribeEventHandle() {
        // 取消订阅
            this.unSubscribeEventHandle();
            // 收到连接断开消息
            this.rtcEngine.subscribeEvent(eventNameConstants.ON_DISCONNECT, this.onDisconnectHandle);
        }
    }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
